// IQ Environment.
type IQEnvironment = 'development' | 'staging' | 'production';
export const ENVIRONMENT: IQEnvironment =
  (process.env.NEXT_PUBLIC_IQ_ENVIRONMENT as IQEnvironment) || 'development';

// Session cookie name.
export const SESSION_COOKIE_NAME = process.env.NEXT_PUBLIC_COOKIE_NAME;

// Frontend URL.
export const FRONTEND_URL = process.env.NEXT_PUBLIC_FRONTEND_URL;

// Backend URL.
const isServer = typeof window === 'undefined';
export const BACKEND_URL = isServer ? process.env.BACKEND_URL : '';

// The Loop URL.
export const THE_LOOP_URL = process.env.NEXT_PUBLIC_THE_LOOP_URL;

// Annotations dashboard URL (admin-only links, e.g. edit-in-annotations buttons).
export const ANNOTATIONS_URL = process.env.NEXT_PUBLIC_ANNOTATIONS_URL;

export function theLoopReturnUrl(ssoToken?: string): string {
  const params = new URLSearchParams({submitted: '1'});
  if (ssoToken) params.set('sso_token', ssoToken);
  return `${THE_LOOP_URL}/?${params.toString()}`;
}
